module.exports = __webpack_public_path__ + "media/images/front/varieties/NAVEL-POWELL-788d96ed9115da7c5408db23d260d629.jpg";